













import { Alert } from "@/types/alert";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AlertEnableToggle extends Vue {
  @Prop({ required: true })
  alert!: Alert;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  isSaving = false;

  get buttonClass() {
    return this.alert.enabled ? "button-primary" : "";
  }

  get title() {
    return this.alert.enabled ? "Enabled" : "Disabled";
  }

  toggleEnabled() {
    this.alert.enabled = !this.alert.enabled;
    this.$ga.button(`Alert ${this.title}`);

    this.isSaving = true;

    this.$store.dispatch("alerts/update", this.alert).then(() => {
      this.isSaving = false;
    });
  }
}
